import { time } from "console";
import React, { useState, useEffect, FC, memo } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import Modal from "../../ui/Modal";
import { updateWorkDate } from "../redux/global";
import { CanChuyen } from "../restapi/canChuyen";
import store from "../store";
import MyTextInput from "../ui/myTextInput";
import { tienFormat, tienFormatFixed } from "../utils/NumberUtils";
import { BetUtils } from "./betUtils";
import InputText from "../../ui/InputText";
import worker from "../setupWorker";
import ConfirmDialog from "../../ui/ConfirmDialog";
import LotCheckBox from "../ui/lotCheckBox";
type OwnProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (sms: string) => void;
}
const ThongKeDBMienBacDialog: FC<OwnProps> = (
    {
        isOpen,
        onClose,
        onConfirm,
    }
) => {
    let strSaved = localStorage["saveObjBet"]
    let saveObjBet: any = undefined
    let trungItemId = 'id1'
    if (strSaved == undefined || strSaved == null || strSaved == 'undefined') {
        saveObjBet = {
            ngay: store.getState().global.workDate,
            sttTu: 41,
            sttDen: 100,
            phanbu: 1000, // con to nhất cộng phần bù bù= số TRỪ, LẤY SỐ này trừ đi điểm khách chơi, ra điểm choi
            tien: 1000,
            heSo: 1,
            datas: [] as any,
            catText: '1-50;',

        }
        localStorage["saveObjBet"] = JSON.stringify(saveObjBet)

    } else {
        saveObjBet = JSON.parse(strSaved)
    }
    const [state, setState] = useState({
        ngay: store.getState().global.workDate,
        sttTu: 41,
        sttDen: 100,
        phanbu: 1000, // con to nhất cộng phần bù bù= số TRỪ, LẤY SỐ này trừ đi điểm khách chơi, ra điểm choi
        tien: 1000,
        heSo: 1,
        datas: [] as any,
        catText: '1-50;',
        time: '18:26:00',
        avgCnt: 0,
        confirmFreezeShow: false,
        loaiCuocIds: ['De', 'Duoi2C'],

    })
    function saveDataLocal() {
        saveObjBet = {

            sttTu: state.sttTu,
            sttDen: state.sttDen,
            phanbu: state.phanbu, // con to nhất cộng phần bù bù= số TRỪ, LẤY SỐ này trừ đi điểm khách chơi, ra điểm choi
            tien: state.tien,
            heSo: state.heSo,
            datas: [] as any,
            time: state.time,
            catText: state.catText,
        }
        localStorage["saveObjBet"] = JSON.stringify(saveObjBet)
    }
    function handleGetDataOnclick() {
        saveDataLocal()
        const loaiCuocIds = state.loaiCuocIds;
        CanChuyen.getThongKeDbMbKhachChoi({ ngay: state.ngay, timeTo: state.time, loaiCuocIds }).then(res => {
            if (res.data) {
                if (res.data.length > 0) {
                    //const soTru = res.data[0].diem + state.phanbu
                    //setState(prev => ({ ...prev, soTru: soTru }))
                }
                setState(prev => ({ ...prev, datas: res.data, avgCnt: res.dataEx }))

            }
            else {
                setState(prev => ({ ...prev, datas: [] }))
            }

        })

    }
    function handleGetDataOnclickAvg() {
        saveDataLocal()
        const loaiCuocIds = state.loaiCuocIds;

        CanChuyen.getThongKeDbMbKhachChoiAvg({
            ngay: state.ngay, timeTo: state.time,
            loaiCuocIds: loaiCuocIds
        }).then(res => {
            if (res.data) {
                if (res.data.length > 0) {
                    //const soTru = res.data[0].diem + state.phanbu
                    //setState(prev => ({ ...prev, soTru: soTru }))
                }
                setState(prev => ({ ...prev, datas: res.data, avgCnt: res.dataEx }))

            }
            else {
                setState(prev => ({ ...prev, datas: [] }))
            }

        })

    }
    function handleExportDataOnclick() {
        const arr = state.catText.split(';')
        let sms = ''
        for (let el of arr) {
            const [tu, den] = el.split('-');
            const payload = {
                soCuocFieldName: 'soCuoc',
                sttTu: Number(tu),
                sttDen: Number(den),
                datas: state.datas,
                tien: state.tien,
                heSo: state.heSo,
            }
            const tmp = BetUtils.exportSoCuoc(payload)
            sms += sms == '' ? tmp : '\n' + tmp
        }

        saveDataLocal()
        onConfirm(sms)
        onClose()
    }
    useEffect(() => {
        setState(prev => ({ ...prev, ...saveObjBet }))
    }, [])
    function sortDiemDesc() {
        const sortedDatas = [...state.datas].sort((a, b) => b.diem - a.diem);
        for (let i = 0; i < sortedDatas.length; i++) {
            sortedDatas[i].stt = i + 1;
        }
        setState(prev => ({ ...prev, datas: sortedDatas }))
    }
    function sortCntDesc() {
        const sortedDatas = [...state.datas].sort((a, b) => b.cnt - a.cnt);
        for (let i = 0; i < sortedDatas.length; i++) {
            sortedDatas[i].stt = i + 1;
        }
        setState(prev => ({ ...prev, datas: sortedDatas }))
    }
    // scroll đến số trúng
    useEffect(() => {
        const el = document.getElementById(`${trungItemId}`);
        if (el) {
            el.scrollIntoView();
        }
    }, [state.datas]);
    function freezeBetDe() {
        const tmp = structuredClone(state.datas);
        const date = state.ngay;
        for (let item of tmp) {
            item['date'] = date;
        }
        CanChuyen.freezeBetDe(tmp).then(res => {
            worker.postMessage({ type: 'showsnackbar', data: res.responseText })
        });

    }
    function handleGetFreezeBetDe() {
        saveDataLocal()
        //mockup data
        // const tmp: any[] = [];
        // for (let i = 0; i < 100; i++) {
        //     tmp.push({ soCuoc: i, diem: i * 1000 })
        // }
        CanChuyen.getFreezeBetDe(state.ngay).then(res => {
            if (res.data) {
                if (res.data.length > 0) {
                    //const soTru = res.data[0].diem + state.phanbu
                    //setState(prev => ({ ...prev, soTru: soTru }))
                }
                setState(prev => ({ ...prev, datas: res.data, avgCnt: res.dataEx }))

            }
            else {
                setState(prev => ({ ...prev, datas: [] }))
            }

        })

    }
    function handleLoaiCuocIdsChange(e: React.ChangeEvent<HTMLInputElement>) {
        let tmp = [...state.loaiCuocIds]
        const value = e.target.value;
        if (e.target.checked) {
            if (!tmp.includes(value)) {
                tmp.push(value)
            }
        } else {
            tmp = tmp.filter(loai => loai != value)
        }
        setState(prev => ({ ...prev, loaiCuocIds: tmp }))
    }
    return <Modal
        isOpen={isOpen}
        onClose={onClose}
    >
        <div className="" style="height: 90vh ; position:relative;">
            <div className=" flex-columns">
                <div className=" common-container-row">
                    <input type='date' className=" date-input"
                        value={state.ngay}
                        onChange={(e) => {
                            setState(prev => ({ ...prev, ngay: e.target.value }))
                            store.dispatch(updateWorkDate({ workDate: e.target.value }))
                        }}
                    ></input>
                    <Button round color="translucent"
                        onClick={handleGetDataOnclick}
                    > <i className=" icon icon-reload" ></i>
                    </Button>
                    <Button round color="translucent"
                        onClick={handleGetDataOnclickAvg}
                    > <i className=" icon icon-archive-filled" ></i>
                    </Button>
                    <Button round color="translucent"
                        onClick={handleExportDataOnclick}
                    > <i className=" icon icon-add" ></i>
                    </Button>
                </div>
                <div className=" common-container-row">
                    <InputText value={state.catText}
                        label="Khoảng cách nhau bởi ;"
                        id={"mb-catText"}
                        onChange={(e) => {

                            setState(prev => ({ ...prev, catText: e.target.value }))


                        }} />
                    <Button round color="translucent" onClick={handleGetFreezeBetDe}>
                        <i className=" fa fa-arrow-turn-up"> </i>
                    </Button>
                    <Button round color="translucent"
                        onClick={() => setState(prev => ({ ...prev, confirmFreezeShow: true }))}>
                        <i className=" fa fa-floppy-disk"> </i>
                    </Button>
                </div>
                <div className=" common-container-row">
                    <MyTextInput value={state.time} label={""} id={""}
                        onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                            setState(prev => ({ ...prev, time: e.target.value }));
                        }}></MyTextInput>
                    <LotCheckBox value='De' text="De" onChange={handleLoaiCuocIdsChange}
                        checked={state.loaiCuocIds.includes('De')}
                    ></LotCheckBox>
                    <LotCheckBox value='Duoi2C' text="Duoi2C" onChange={handleLoaiCuocIdsChange}
                        checked={state.loaiCuocIds.includes('Duoi2C')}
                    ></LotCheckBox>
                    <div>avg{state.avgCnt}</div>
                </div>
                <div className=" grid-4-cols">
                    <div className=" stt">
                        STT
                    </div>
                    <div>
                        Số cược
                    </div>
                    <div onClick={sortDiemDesc}>
                        Điểm
                    </div>
                    <div onClick={sortCntDesc}>
                        CNT
                    </div>
                </div>

            </div>
            <div className=" form-content" style='height:calc(80vh - 10rem );padding:0px; gap:0px;'>

                {

                    state.datas.map((item: any) => {
                        if (item.trung != 0) {
                            trungItemId = `id${item.stt}`;
                        }
                        return <div className=" grid-4-cols" key={item.stt}
                            id={`id${item.stt}`}>
                            <div className={" stt" + (item.trung != 0 ? " trung" : "")}
                                style='font-weight:700; font-size:0.8rem;'>
                                {item.stt}
                            </div>
                            <div className={item.trung != 0 ? " trung" : ""}>
                                {item.soCuoc}
                            </div>
                            <div className={'tkkc-diem ' + (item.trung != 0 ? " trung" : "")}>
                                {tienFormatFixed(item.diem, 2)}
                            </div>
                            <div className={'tkkc-cnt ' + (item.trung != 0 ? " trung" : "")}>
                                {item.cnt}
                            </div>
                        </div>
                    })

                }
                <div>.</div>
            </div>
        </div>
        <ConfirmDialog
            title="Xác nhận lưu"
            isOpen={state.confirmFreezeShow}
            confirmHandler={() => {
                setState(prev => ({ ...prev, confirmFreezeShow: false }))
                freezeBetDe()
            }}
            onClose={() => {
                setState(prev => ({ ...prev, confirmFreezeShow: false }))
            }}></ConfirmDialog>
    </Modal>
}
export default memo(ThongKeDBMienBacDialog);